import {
    createBulk,
    getCustomers,
    getRepeatDetails,
    getFilterCustomerCount,
} from 'crm/services/group-bulk'
import createModel from 'utils/model'

const initState = () => ({
    checkAll: false,
    query: null, // 全选：客户管理带来的params
    checkAllNums: 0, // 全选：客户数量
    selectedRowKeys: [], // 非全选：客户管理带过来的客户ids
    repeatDetails: null, // 重发详情
    filterCustomerCount: undefined, // 计算过滤后的群发客户数量
})

export default createModel({
    namespace: 'crm_groupBulk_createBulk',

    state: initState(),

    effects: {
        *createBulk({payload, callback}, {call}) {
            const data = yield call(createBulk, payload)
            if (data) {
                callback && callback(data)
            }
        },

        // 获取客户数量
        *getCustomers({payload}, {call, put}) {
            const res = yield call(getCustomers, payload)
            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        checkAllNums: res.pagination?.rows_found,
                    },
                })
            }
        },

        // 重发详情：重发的是ids类型，非全选类型
        *getRepeatDetails({payload, callback}, {call, put}) {
            const res = yield call(getRepeatDetails, payload)
            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        repeatDetails: res.data,
                        checkAll: false,
                    },
                })
                callback && callback(res.data)
            }
        },

        // 计算过滤后的群发客户数量
        *getFilterCustomerCount({payload}, {call, put}) {
            const res = yield call(getFilterCustomerCount, payload)
            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        filterCustomerCount: res.data?.count,
                    },
                })
            }
        },
    },

    reducers: {
        resetState(state) {
            return {...state, ...initState()}
        },
    },
})
